import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Icon from "../../Icon";
import styleSelectListOption from "../../Form/Select/SelectListOption/style.module.scss";
import style from "./style.module.scss";
export function SelectURLOption({ option, selected, multiple, hideIcon }) {
    const optionLabel = [];
    if (option.label) {
        optionLabel.push(_jsx("div", { className: style["select-url-option__page-label"], children: option.label }));
    }
    return (_jsx("div", { role: "menuitem", className: classNames(styleSelectListOption["select-list-option"], {
            [styleSelectListOption["select-list-option--selected"]]: selected,
        }), children: _jsxs("label", { className: classNames(styleSelectListOption["select-list-option__label"], "qa-select-list-option__label"), children: [hideIcon !== true && (_jsx("div", { className: multiple
                        ? styleSelectListOption["select-list-option__checkbox"]
                        : styleSelectListOption["select-list-option__radio"], children: selected && multiple ? _jsx(Icon, { name: "check" }) : null })), optionLabel, _jsx("div", { className: style["select-url-option__url"], children: option.url })] }) }));
}
